'use client';

import { CloseIcon } from '@/assets';
import { useIsModalOpen, useModalStore } from '@/store';

export const Modal = ({ children }: { children: React.ReactNode }) => {
  const isOpen = useIsModalOpen();
  const closeModal = useModalStore((state) => state.closeModal);

  return (
    <div
      className={`z-50 w-full fixed inset-0 flex items-center justify-center bg-black/65 backdrop-blur-lg transition-opacity duration-500 ease-out ${
        isOpen
          ? 'opacity-100 pointer-events-auto'
          : 'opacity-0 pointer-events-none'
      }`}
      aria-hidden={!isOpen}
    >
      <div
        className={`p-6 w-full relative h-full overflow-y-auto no-scrollbar transform transition-all duration-500 ease-out ${
          isOpen ? 'translate-y-0 opacity-100' : '-translate-y-6 opacity-0'
        }`}
      >
        <button
          type="button"
          className="absolute top-4 right-4 bg-white bg-opacity-20 rounded-full p-2 hover:bg-opacity-30 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/70"
          onClick={closeModal}
          tabIndex={isOpen ? 0 : -1}
          aria-label="Close modal"
        >
          <CloseIcon width={24} height={24} />
        </button>
        {children}
      </div>
    </div>
  );
};
